import React from 'react';

import { CartPage } from '@/pages/cart';

import { AppProviders } from '@/shared/components/Providers';
import { APP_ELEMENTS } from '@/shared/constants';
import { Modal } from '@/shared/services/modal';
import { Notification } from '@/shared/services/notification';
import { CartTheme } from '@/shared/themes';

import store from './store';

const App: React.FC = () => {
  return (
    <AppProviders resources={window.cart.resources} store={store} theme={CartTheme}>
      <CartPage />
      <Modal appElement={APP_ELEMENTS.CART} />
      <Notification />
    </AppProviders>
  );
};

export default App;
